export const preSeedCopy = {
  en: {
    eyebrow: 'PRE-SEED / A SHARED BEGINNING',
    title: 'Pre-seed investment.',
    subtitle: 'Build the foundations. Think long term.',
    vision: 'Our pre-seed vision is to turn focused product development into demonstrated customer value—starting with Sri and supported by secure, accountable operations.',
    prioritiesTitle: 'PROPOSED CAPITAL PRIORITIES',
    productTitle: 'Focused product development',
    productBody: 'Prioritize Sri and the essential workflows behind a useful first commercial product.',
    customersTitle: 'Customer discovery & adoption',
    customersBody: 'Validate demand, onboarding and willingness to pay before expanding.',
    trustTitle: 'Security, compliance & trust',
    trustBody: 'Strengthen the technical and governance foundations for responsible growth.',
    prioritiesNote: 'Intended priorities, subject to company review. No allocation or outcome is guaranteed.',
    processTitle: 'A CONSIDERED REVIEW PROCESS',
    step1: 'Express interest', step2: 'Team & eligibility review', step3: 'Approved private discussion',
    widgetEyebrow: 'START THE CONVERSATION',
    widgetTitle: 'Your interest. Your perspective.',
    widgetDescription: 'Choose an illustrative cheque size to carry into your guest interest form.',
    amountLabel: 'Indicative cheque size',
    amountHint: 'Indian rupees · You can edit the amount on the next step.',
    chequeOptions: 'Illustrative cheque sizes',
    selectCheque: 'Select {{amount}}',
    lakhUnit: 'lakh',
    croreUnit: 'crore',
    chequeDisclaimer: 'Illustrative amounts—not minimums, approved terms or eligibility categories.',
    continue: 'Continue with this amount',
    noAccount: 'No account required. Nothing is submitted at this step.',
    nonbinding: 'Nonbinding interest only—not an investment commitment. No payment is taken.',
    privacyNote: 'Detailed investment documents and ownership records remain private, subject to eligibility and company approval. Public estimator figures are illustrative.',
    riskLink: 'Risk considerations',
    pageLink: 'Explore the pre-seed page',
  },
  hi: {
    eyebrow: 'प्री-सीड / एक साझा शुरुआत',
    title: 'प्री-सीड निवेश।',
    subtitle: 'मज़बूत नींव। दीर्घकालिक सोच।',
    vision: 'हमारा प्री-सीड दृष्टिकोण केंद्रित उत्पाद विकास को वास्तविक ग्राहक मूल्य में बदलना है—श्री से शुरुआत करते हुए, सुरक्षित और जवाबदेह संचालन के साथ।',
    prioritiesTitle: 'प्रस्तावित पूँजी प्राथमिकताएँ',
    productTitle: 'केंद्रित उत्पाद विकास',
    productBody: 'श्री और पहले उपयोगी वाणिज्यिक उत्पाद के आवश्यक कार्यप्रवाहों को प्राथमिकता देना।',
    customersTitle: 'ग्राहक खोज और अपनाना',
    customersBody: 'विस्तार से पहले माँग, ऑनबोर्डिंग और भुगतान करने की इच्छा की पुष्टि करना।',
    trustTitle: 'सुरक्षा, अनुपालन और विश्वास',
    trustBody: 'जिम्मेदार विकास के लिए तकनीकी और शासन संबंधी नींव को मज़बूत करना।',
    prioritiesNote: 'ये इच्छित प्राथमिकताएँ कंपनी की समीक्षा के अधीन हैं। किसी आवंटन या परिणाम की गारंटी नहीं है।',
    processTitle: 'एक विचारपूर्ण समीक्षा प्रक्रिया',
    step1: 'रुचि व्यक्त करें', step2: 'टीम और पात्रता समीक्षा', step3: 'अनुमोदित निजी चर्चा',
    widgetEyebrow: 'संवाद शुरू करें',
    widgetTitle: 'आपकी रुचि। आपका दृष्टिकोण।',
    widgetDescription: 'अतिथि निवेश-रुचि फ़ॉर्म के लिए एक उदाहरणात्मक चेक राशि चुनें।',
    amountLabel: 'सांकेतिक चेक राशि',
    amountHint: 'भारतीय रुपये · अगले चरण में आप राशि बदल सकते हैं।',
    chequeOptions: 'उदाहरणात्मक चेक राशियाँ',
    selectCheque: '{{amount}} चुनें',
    lakhUnit: 'लाख',
    croreUnit: 'करोड़',
    chequeDisclaimer: 'ये उदाहरणात्मक राशियाँ हैं—न्यूनतम राशि, स्वीकृत शर्तें या पात्रता श्रेणियाँ नहीं।',
    continue: 'इस राशि के साथ आगे बढ़ें',
    noAccount: 'खाते की आवश्यकता नहीं। इस चरण में कुछ भी जमा नहीं होता।',
    nonbinding: 'केवल गैर-बाध्यकारी रुचि—निवेश की प्रतिबद्धता नहीं। कोई भुगतान नहीं लिया जाता।',
    privacyNote: 'विस्तृत निवेश दस्तावेज़ और स्वामित्व रिकॉर्ड पात्रता और कंपनी की अनुमति के अधीन निजी रहते हैं। सार्वजनिक अनुमान के आँकड़े केवल उदाहरणात्मक हैं।',
    riskLink: 'जोखिम संबंधी जानकारी',
    pageLink: 'प्री-सीड पृष्ठ देखें',
  },
};